import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

/**
 * Controls the open/close state of the keyboard shortcuts drawer.
 *
 * The drawer's triggers (the `NavResources` dropdown item in the nav and the
 * `VIEW_KEYBOARD_SHORTCUTS` input-system action) and the drawer surface itself
 * are DOM-separated with no nearby common ancestor. Per the perf-team guidance
 * in `AppWithRoutes.tsx`, cross-tree nav↔content state lives in a feature-scoped
 * Zustand store rather than an app-level React context provider.
 */
export type KeyboardShortcutsDrawerStore = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
};

export const useKeyboardShortcutsDrawerStore =
  create<KeyboardShortcutsDrawerStore>()(
    devtools(
      set => ({
        isOpen: false,
        open: () => set({isOpen: true}, false, 'open'),
        close: () => set({isOpen: false}, false, 'close'),
        toggle: () => set(state => ({isOpen: !state.isOpen}), false, 'toggle'),
      }),
      {name: 'KeyboardShortcutsDrawerStore'}
    )
  );
